export default "__VITE_ASSET__Dpkl0WFo__"